import { useQuery } from "@tanstack/react-query";
import { Search, UserSearch } from "lucide-react";
import { useState } from "react";
import { api, errorMessage, unwrap } from "../../api/client";
import { Alert, Badge, Card, Empty, PageHead, Spinner } from "../../components/ui";
import { date, initials, relative } from "../../lib/format";
import { useDebounced } from "./Orgs";

export function AdminUsers() {
  const [q, setQ] = useState("");
  const query = useDebounced(q.trim());
  const users = useQuery({
    queryKey: ["admin-users", query],
    queryFn: () => unwrap(api.GET("/v1/admin/users", { params: { query: { q: query || undefined, limit: 100 } } })),
    placeholderData: (prev) => prev,
  });
  return (
    <>
      <PageHead title="Users" description="Everyone who has signed in. Search by email, name or id; find their company under Organisations." />
      <Card pad={false}>
        <div className="toolbar">
          <div className="input-icon">
            <Search />
            <input className="input" placeholder="Search users" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
          </div>
        </div>
        {users.isLoading ? (
          <Spinner />
        ) : users.error ? (
          <div className="card-body">
            <Alert tone="danger">{errorMessage(users.error)}</Alert>
          </div>
        ) : !users.data?.items.length ? (
          <Empty icon={<UserSearch />} title="No users found" />
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Role</th>
                  <th className="num hide-sm">Joined</th>
                  <th className="num">Last sign-in</th>
                </tr>
              </thead>
              <tbody>
                {users.data.items.map((u) => (
                  <tr key={u.id}>
                    <td>
                      <div className="row" style={{ flexWrap: "nowrap" }}>
                        <div className="org-avatar" style={{ borderRadius: 99 }}>{initials(u.display_name || u.email)}</div>
                        <div style={{ minWidth: 0 }}>
                          <div className="cell-main ellipsis">{u.display_name || u.email}</div>
                          <div className="cell-sub ellipsis">{u.display_name ? u.email : u.id}</div>
                        </div>
                      </div>
                    </td>
                    <td>{u.platform_role ? <Badge tone="grad" plain>platform admin</Badge> : <span className="faint">—</span>}</td>
                    <td className="num hide-sm">{date(u.created_at)}</td>
                    <td className="num">{relative(u.last_login_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
